import {UPDATE_VIEW_PADDING, PAN_ZOOM} from './actions';

const DefaultState = {
  padding: [0, 0, 0, 0]
}

const map = (state = DefaultState, action) => {
  switch (action.type) {
    case UPDATE_VIEW_PADDING:

      return Object.assign({}, {padding: [
  		(action.data[0] !== null ? action.data[0] : state.padding[0]),
  		(action.data[1] !== null ? action.data[1] : state.padding[1]),
  		(action.data[2] !== null ? action.data[2] : state.padding[2]),
  		(action.data[3] !== null ? action.data[3] : state.padding[3]),
  	]});
    case PAN_ZOOM:
        state.coords = action.data.coords;
        state.zoom = action.data.zoom;

        if(action.data.updateSource){
            state.updateSource = action.data.updateSource;
        } else {
            state.updateSource = 'UI';
        }

    return Object.assign({}, state);
    default:
      return state;
  }
}

export {map}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/map/reducer.js